import { render, staticRenderFns } from "./SuggestionsHome.vue?vue&type=template&id=92d36186"
import script from "./SuggestionsHome.vue?vue&type=script&setup=true&lang=js"
export * from "./SuggestionsHome.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports